module.exports = __webpack_public_path__ + "img/fuwu4.2043c7c1.jpg";